import React from "react";
import PropTypes from "prop-types";
import { library } from "@fortawesome/fontawesome-svg-core";
import { faComments } from "@fortawesome/free-solid-svg-icons";
import {
  AccountManagerWrapper,
  AccountManagerInfo,
  AccountManagerPersonalInfo,
  AccountManagerName,
  AccountManagerCompany,
} from "./styles/account-manager-styles";

library.add(faComments);

const AccountManager = ({ accountManager }) => (
  <AccountManagerWrapper>
    <AccountManagerInfo>
      <AccountManagerPersonalInfo>
        <AccountManagerName>{accountManager}</AccountManagerName>
        <AccountManagerCompany>
          Account Manager | Hiring Hub
        </AccountManagerCompany>
      </AccountManagerPersonalInfo>
    </AccountManagerInfo>
  </AccountManagerWrapper>
);
export default AccountManager;
